import { apiRequest } from "../util/apiUtils";

export const leaderboardRoute = async (payload) => {
  try {
    const res = await apiRequest("get", "leaderboard/backend/list", {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const artistLeaderboardRoute = async (payload) => {
  try {
    const res = await apiRequest("get", "leaderboard/backend/artist/list", {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};